import { createSlice } from "@reduxjs/toolkit";
import { userListDropdownAPI } from "../../services/userListDropdown";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const userListDropdownSlice = createSlice({
  name: "userListDropdown",
  initialState: data,
  reducers: {
    userListDropdownInfo(state) {
      state.isLoading = true;
    },
    userListDropdownSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    userListDropdownFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    userListDropdownReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const userListDropdownHandler = (data) => async (dispatch) => {
  try {
    dispatch(userListDropdownAction.userListDropdownInfo());
    const response = await userListDropdownAPI(data);
    dispatch(userListDropdownAction.userListDropdownSuccess(response));
  } catch (e) {
    dispatch(userListDropdownAction.userListDropdownFailure(e?.response?.data?.message));
  }
};
export default userListDropdownSlice.reducer;
export const userListDropdownAction = userListDropdownSlice.actions;
